import { blogArticles } from '@/mocks/categories';

const articleImages: Record<string, string> = {
  "guida-completa": "https://readdy.ai/api/search-image?query=Comprehensive%20guide%20concept%20with%20open%20notebook%20laptop%20and%20organized%20desk%20accessories%20on%20warm%20oak%20surface%2C%20soft%20natural%20daylight%2C%20minimalist%20editorial%20workspace%2C%20warm%20neutral%20tones%2C%20clean%20aesthetic%2C%20no%20text%20no%20logos%20no%20watermarks%2C%20calm%20productive%20atmosphere&width=600&height=400&seq=blog-img-guida&orientation=landscape&nocache=true",
  "recensione": "https://readdy.ai/api/search-image?query=Product%20review%20concept%20with%20laptop%20showing%20five%20star%20rating%20and%20feedback%20form%2C%20on%20light%20grey%20concrete%20desk%2C%20soft%20natural%20window%20light%2C%20minimalist%20editorial%20style%2C%20warm%20neutral%20tones%2C%20no%20text%20no%20logos%20no%20watermarks%2C%20clean%20composition&width=600&height=400&seq=blog-img-recensione&orientation=landscape&nocache=true",
  "sicurezza": "https://readdy.ai/api/search-image?query=Digital%20security%20concept%20with%20laptop%20displaying%20shield%20lock%20icon%2C%20padlock%20key%20and%20secure%20document%20on%20slate%20surface%2C%20soft%20dramatic%20lighting%2C%20minimalist%20professional%20photography%2C%20cool%20grey%20tones%20with%20warm%20accents%2C%20no%20text%20no%20logos%20no%20watermarks&width=600&height=400&seq=blog-img-sicurezza&orientation=landscape&nocache=true",
  "confronto": "https://readdy.ai/api/search-image?query=Side%20by%20side%20comparison%20concept%20with%20two%20tablets%20showing%20different%20interfaces%2C%20on%20light%20marble%20surface%2C%20soft%20natural%20daylight%2C%20minimalist%20editorial%20photography%2C%20warm%20neutral%20tones%2C%20no%20text%20no%20logos%20no%20watermarks%2C%20balanced%20composition&width=600&height=400&seq=blog-img-confronto&orientation=landscape&nocache=true",
};

export default function BlogSection() {
  return (
    <section id="articoli" className="py-20 md:py-28 bg-background-100">
      <div className="w-full px-6 md:px-10 lg:px-16 max-w-7xl mx-auto">
        <div className="mb-16">
          <p className="text-xs text-foreground-500 tracking-wider uppercase mb-3 font-medium">
            Blog &amp; Guide
          </p>
          <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-4">
            <div>
              <h2 className="font-heading text-3xl md:text-5xl font-semibold text-foreground-950 leading-tight">
                Guide Complete
              </h2>
              <h2 className="font-heading text-3xl md:text-5xl italic text-primary-500 leading-tight mt-1">
                e Recensioni
              </h2>
            </div>
            <p className="text-foreground-600 text-sm md:text-base max-w-md">
              Articoli originali e aggiornati su Itaobuy Spreadsheet. Guide, recensioni,
              tutorial e confronti per aiutarti a scegliere il miglior strumento.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {blogArticles.map((article) => (
            <a
              key={article.id}
              href={article.url}
              className="group rounded-2xl overflow-hidden bg-white border border-background-200/70 hover:shadow-md transition-all duration-300 cursor-pointer flex flex-col"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={articleImages[article.id]}
                  alt={article.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent" />
                <div className="absolute bottom-3 left-4">
                  <span className={`text-xs font-medium px-2.5 py-1 rounded-full bg-white/80 ${article.textColor}`}>
                    {article.id === 'guida-completa' ? 'Guida' : article.id === 'recensione' ? 'Recensione' : article.id === 'sicurezza' ? 'Sicurezza' : 'Confronto'}
                  </span>
                </div>
              </div>
              <div className="p-5 flex-1 flex flex-col">
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-2 leading-snug group-hover:text-primary-500 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-3 flex-1">
                  {article.excerpt}
                </p>
                <span className="inline-flex items-center gap-1.5 text-xs font-medium text-primary-500 mt-4 group-hover:gap-2 transition-all">
                  Leggi l&apos;articolo
                  <i className="ri-arrow-right-line w-3 h-3 flex items-center justify-center"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}